// src/components/Webview.tsx
import { forwardRef } from 'react';

interface WebviewProps {
  url: string;
  className?: string;
  onLoad?: () => void;
}

export const Webview = forwardRef<HTMLIFrameElement, WebviewProps>(({ url, className, onLoad }, ref) => {
  return (
    <div className={`w-full h-full relative ${className || ''}`}>
      {url && (
        <iframe
          ref={ref}
          src={url}
          title="Application Preview"
          className="w-full h-full border-0"
          onLoad={() => {
            onLoad?.();
          }}
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-modals allow-downloads allow-presentation allow-orientation-lock allow-pointer-lock"
        />
      )}
    </div>
  );
});
Webview.displayName = 'Webview';
